import { keyframes, styled } from '@pulse-web-ui/theme';

const pulse = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
`;

export const Loader = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 50px;
  gap: 7px;
`;

export const Dot = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${({ theme }) => theme.colors.accent.action.normal};
  border-radius: 50%;
  animation: ${pulse} 1.4s infinite ease-in-out both;

  &:nth-child(1) {
    animation-delay: -0.32s;
  }
  &:nth-child(2) {
    animation-delay: -0.16s;
  }
  &:nth-child(3) {
    animation-delay: 0s;
  }
`;
